import * as React from 'react';
import { Typography, tok, space } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

export function MandatoryCosts(props: { mandatoryCosts: string[]; mandatoryHeader: string }) {
  const { mandatoryCosts, mandatoryHeader } = props;
  return (
    <MandatoryBox>
      {mandatoryCosts && mandatoryCosts.length > 0 && mandatoryHeader && (
        <MandatoryHeaderText $variant="body-md-bold">{mandatoryHeader ?? ''}</MandatoryHeaderText>
      )}
      {mandatoryCosts?.map((mandatoryCost, index) => {
        return <MandatoryText key={index}>{mandatoryCost ?? ''}</MandatoryText>;
      })}
    </MandatoryBox>
  );
}

const MandatoryBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
`;

const MandatoryHeaderText = styled(Typography)`
  margin-bottom: ${space('primitives_space_0')};
`;

const MandatoryText = styled(Typography)`
  font-size: ${tok('primitives_font_size_body_xs')}px;
  letter-spacing: 0.26px;
  margin-bottom: ${space('primitives_space_0')};
  line-height: ${tok('primitives_line_height_tight')};
`;
